import { endpointWrapper } from './meta.api';

export const getPopularityData = async (config) =>
    endpointWrapper({
        domain: 'pop_index/data_points',
        ...config,
    });

export const getPopularityGoogleTimeSeriesMonthly = async (config) =>
    endpointWrapper({
        domain: 'pop_index/time_series/monthly/google',
        ...config,
    });

export const getPopularityTikTokTimeSeriesMonthly = async (config) =>
    endpointWrapper({
        domain: 'pop_index/time_series/monthly/tiktok',
        ...config,
    });

export const getPopularityInstagramTimeSeriesMonthly = async (config) =>
    endpointWrapper({
        domain: 'pop_index/time_series/monthly/instagram',
        ...config,
    });

export const getRelatedCategoriesPopularityData = async (config) =>
    endpointWrapper({
        domain: 'pop_index/related_categories',
        ...config,
    });

export const getRelatedCategoriesInPairsPopularityData = async (config) =>
    endpointWrapper({
        domain: 'pop_index/related_category_pairs',
        ...config,
    });

export const getRelatedBrandsPopularityData = async (config) =>
    endpointWrapper({
        domain: 'pop_index/related_brands',
        ...config,
    });

export const getPopIndexRelatedCategoryGroups = async (config) =>
    endpointWrapper({
        domain: 'pop_index/related_category_groups',
        ...config,
    });
